// extracted by mini-css-extract-plugin
module.exports = {"card":"dashboard-highlights-card_card__Ngx7z"};